export const displayPublishStatus = (value: string, Translation: any) => {
    if (value === null || value === '') {
        return {
            label: '',
            value: ''
        }
    }
    
    switch (value.toString()) {
        case '0':
            return {
                label: Translation('event.publish.status.Draft.label'),
                value: '0'
            }
        case '1':
            return {
                label: Translation('event.publish.status.Published.label'),
                value: '1'
            }
        case '2':
            return {
                label: Translation('event.publish.status.Unpublished.label'),
                value: '2'
            }   
        case '3':
                return {
                    label: 'Publishing',
                    value: '3'
                }   
        default:
            return {
                label: '',
                value: ''
            }
            break;
    }
}